'use client';
import React from 'react';

interface MobileWrapperProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const MobileWrapper: React.FC<MobileWrapperProps> = ({ 
  children, 
  className = '',
  padding = 'md'
}) => {
  const paddingClasses = {
    none: '',
    sm: 'px-2',
    md: 'px-4',
    lg: 'px-6'
  };

  return (
    <div data-component-id="src/components/common/MobileWrapper.tsx:23:4" data-component-path="src/components/common/MobileWrapper.tsx" data-component-line="23" data-component-file="MobileWrapper.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${paddingClasses[padding]} ${className}`}>
      {children}
    </div>
  );
};

export default MobileWrapper; 